import { createSlice } from '@reduxjs/toolkit';
import { regionApi, regionAssetApi } from '../services';
import { MY_ACCOUNT_LIST, getDeviceDetail } from '../utils';
import { RootState } from './index';

interface IAccount {
  assets: Record<string, any>;
}

const initialState: IAccount = {
  assets: { [MY_ACCOUNT_LIST]: {} }
};

const accountSlice = createSlice({
  name: 'asset',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addMatcher(
      regionApi.endpoints.regionLogin.matchFulfilled,
      (state, { payload }) => {
        const region: Record<string, any> = payload || {};
        if (region?.groups) {
          region?.groups.flat(1).forEach((obj: Record<string, any>) => {
            if (obj?.id) {
              state.assets[obj?.id] = state.assets[obj?.id] || {};
            }
          });
        }
      }
    );
    builder.addMatcher(
      regionAssetApi.endpoints.getAssetByAccount.matchFulfilled,
      (state, { payload }) => {
        if (payload?.account_id) {
          let asset = payload?.data || {};
          const devices = getDeviceDetail(asset);
          const group_id = payload?.group_id || MY_ACCOUNT_LIST;
          if (state.assets[group_id]) {
            state.assets[group_id][payload?.account_id] = {
              asset: payload?.data,
              devices: devices,
              deviceNum: devices?.number,
              deviceHealth: devices?.health
            };
          } else {
            console.warn(
              '------------- asset store not found correct group id',
              group_id
            );
          }
        }
      }
    );
  }
});

const { reducer, actions } = accountSlice;

export const selectAssets = (state: RootState) => state.asset?.assets;
export default reducer;
